// removed by extract-text-webpack-plugin
module.exports = {"box":"_2qy_42RalpMOA1ru697qJp","left":"_3S8LtW2vcPksBG9R45QWrq","right":"_3Rzn4FGns9LdCxs4g3khuP","title":"_29GgrqrjDKENZiSQzUOqgf","description":"DdFD0W0sZCgn_W3YUxtjU","image":"_3wrAlKv6VM3Oq-B1zgsnqw","headerbox":"xF5G-0Afn6bhg6xYUbUw3","type-button":"_4qZIPzJ6SGwQwS7P23tzy","typeButton":"_4qZIPzJ6SGwQwS7P23tzy","type-button-scaleup":"_23cJVvg1s89v0OafnJKVgh","typeButtonScaleup":"_23cJVvg1s89v0OafnJKVgh","type-button-scaledown":"_3i01-J9QA7pwDzkuwkNWJS","typeButtonScaledown":"_3i01-J9QA7pwDzkuwkNWJS"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/storydoc/vertiefungBox/vertiefungBox.css
// module id = 389
// module chunks = 0